class reservationServices {
    
    async registerReservation(p_key, p_nom, p_email,p_idObject, setIsDataRegistering, setIsCompleted, setError, p_object) {

        console.log("registerReservation service debut");
        let v_retour = null;
        const requestOptions = {
            method: "POST",
            mode: 'cors',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email: p_email,
                name : p_nom,
                idObject : p_idObject
            }),
        };

        try {
            let v_responseJson = {};
                setIsDataRegistering && setIsDataRegistering(true)
                const response = await fetch("https://app.listaki.fr/api/WS/reservation.php?key="+p_key, requestOptions)
                if (response.ok) {
                    v_responseJson = await response.json();
                    console.log("Reponse api debut");
                    console.log(v_responseJson)
                    console.log("Reponse api fin");
                    if(v_responseJson["success"]) v_retour = v_responseJson["reservationId"]
                    else alert(v_responseJson["error"])
                    setIsCompleted && setIsCompleted(true);
                } else {
                    console.log("Erreur lors de l'appel à l'API");
                    v_responseJson = await response.json();
                    if(v_responseJson["error"]) alert(v_responseJson["error"])
                    setError && setError(true);
                }
        } catch (err) {
            console.log(err)
        } finally {
             setIsDataRegistering&& setIsDataRegistering(false)
        }
        return v_retour;
    };

    async getReservationInfo(p_key, reservationId) {
        try {
            const url = `https://app.listaki.fr/api/WS/getReservation.php?key=${encodeURIComponent(p_key)}&id=${encodeURIComponent(reservationId)}`;
            const response = await fetch(url, { method: 'GET', mode: 'cors' });
            const data = await response.json();
            if (!response.ok || !data.success) {
                throw new Error(data.error || 'Erreur lors de la récupération de la réservation');
            }
            return data.reservation;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

}

export default new reservationServices();
